import React, { Component } from 'react';
import Vas from '../Vas';
import { LinkButton } from 'component-lib';

class ActivateEMailSuccess extends Component
{
  constructor(props)
  {
    super(props);
    this.state = {};
    this.CustomerId = props.match.params.CustomerId;
  }

  render()
  {
    return ( <div className="LoginContainer">
      <div 
        className={"form"} 
        style={{ width:'400px' }}>
        <table>
          <thead>
            <tr>
              <th colSpan={2}><h2>{Vas.Resources.Labels["ActivateEmail"]}</h2></th>
            </tr>
          </thead>
          <tbody >
            <tr>
              <td style={{ fontSize:'14px', float: 'right' }}>{Vas.Resources.Labels["LinkLoginFemininum"]}</td>
              <td><LinkButton 
                Text={Vas.Resources.Labels["OverviewCustumerData"]} 
                Id={"LinkLogin"} 
                OnClick={()=>{Vas.GetView("CustomerCard",{ Id:localStorage.getItem("vas_customerId") },true);}}
              />
              </td>
            </tr>
          </tbody>
        </table> 
      </div>
    </div>);
  }
}
export default ActivateEMailSuccess;
